import { render, staticRenderFns } from "./SponsorshipSpotlightUpdate.vue?vue&type=template&id=0141af5c&scoped=true&"
import script from "./SponsorshipSpotlightUpdate.vue?vue&type=script&lang=js&"
export * from "./SponsorshipSpotlightUpdate.vue?vue&type=script&lang=js&"
import style0 from "./SponsorshipSpotlightUpdate.vue?vue&type=style&index=0&id=0141af5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0141af5c",
  null
  
)

export default component.exports